export default function uncompleteChecklistItem ({ dispatch }, itemId) {
  return dispatch('updateChecklistItem', {
    id: itemId,
    completedOn: null
  })
}
